import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'

import type {
	ISdkStateServiceConfig,
	ISdkStateService,
	ISdkStateDefinition } from '@wix/viewer-service-sdk-state/definition'
import {
	SdkStateDefinition as definition
} from '@wix/viewer-service-sdk-state/definition'
import { SdkStateService as impl } from '@wix/viewer-service-sdk-state/implementations'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'

export const sdkStateService = withDependencies(
	[],
	(): ServiceProvider<
		ISdkStateDefinition,
		(opts: ServiceFactoryOpts<ISdkStateServiceConfig>) => ISdkStateService
	> => {
		return {
			definition,
			impl,
			config: {},
			platformConfig: {},
		}
	}
)
